



import React, { useState } from "react";

const RequiredTestsDropdown = ({ formData, setFormData }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [openSection, setOpenSection] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);

  const testOptions = [
    // Profile List (no sub-tests)
    ...[
      "Complete Blood Picture - CBC",
      "ESR",
      "Haemoglobin",
      "Functional Medicine Test",
      " C-Reactive Protein (CRP) ",
      "Blood Group Tests For Blood Type ",
      "Genetic Wellness Test",
      "Hereditary Cancer Screening",
      "Non-Invasive Prenatal Testing (NIPT)",
     
    ].map(name => ({ category: name, tests: [] })),

    // Test List (with sub-tests)
    {
      "category": "Diabetic Profile",
      "tests": [
        { "value": "HbA1c", "label": "HbA1c" },
        { "value": "GlucoseFasting", "label": "Glucose - Fasting" }
      ]
    },
    {
      "category": "Molecular Allergy Profile",
      "tests": [
       
      ]
    },
    {
      "category": "Iron Deficiency Profile",
      "tests": [
        { "value": "Ferritin", "label": "Ferritin" },
        { "value": "Iron", "label": "Iron" },
        { "value": "Transferrin", "label": "Transferrin" },
        { "value": "TIBC", "label": "Total Iron Binding Capacity (TIBC)" }
      ]
    },
    {
      "category": "Stress Profile",
      "tests": [
        { "value": "Cortisol", "label": "Cortisol" },
        { "value": "DHEAS", "label": "DHEA-S" }
      ]
    },
    {
      "category": "Rheumatoid Arthritis Profile",
      "tests": [
        { "value": "RF", "label": "Rheumatoid Factor (RF)" },
        { "value": "CRP", "label": "CRP" },
        { "value": "ESR", "label": "ESR" },
        { "value": "UricAcid", "label": "Uric Acid" },
        { "value": "CBC", "label": "CBC" }
      ]
    },
    {
      "category": "Thyroid Profile",
      "tests": [
        { "value": "TSH", "label": "TSH" },
        { "value": "FT3", "label": "FT3" },
        { "value": "FT4", "label": "FT4" }
      ]
    },
    {
      "category": "Kidney Health",
      "tests": [
        { "value": "Urea", "label": "Urea" },
        { "value": "Potassium", "label": "Potassium" },
        { "value": "Sodium", "label": "Sodium" },
        { "value": "Chloride", "label": "Chloride" },
        { "value": "Creatinine", "label": "Creatinine" },
        { "value": "eGFR", "label": "eGFR" }
      ]
    },
    {
      "category": "Lipid Profile",
      "tests": [
        { "value": "Cholesterol", "label": "Cholesterol" },
        { "value": "HDL", "label": "HDL" },
        { "value": "LDH", "label": "LDH" },
        { "value": "Triglycerides", "label": "Triglycerides" }
      ]
    },
    {
      "category": "Bone Health",
      "tests": [
        { "value": "TotalProtein", "label": "Total Protein" },
        { "value": "Albumin", "label": "Albumin" },
        { "value": "ALP", "label": "Alkaline Phosphatase (ALP)" },
        { "value": "Calcium", "label": "Calcium (Total and Adjusted)" },
        { "value": "Phosphate", "label": "Phosphate" }
      ]
    },
    {
      "category": "Liver Health",
      "tests": [
        { "value": "Albumin", "label": "Albumin" },
        { "value": "AST", "label": "AST / GOT" },
        { "value": "ALP", "label": "ALP" },
        { "value": "GammaGTT", "label": "Gamma GTT" },
        { "value": "TotalBilirubin", "label": "Total Bilirubin" }
      ]
    },
    {
      "category": "Electrolyte Tests",
      "tests": [
        { "value": "Sodium", "label": "Sodium" },
        { "value": "Potassium", "label": "Potassium" },
        { "value": "Chloride", "label": "Chloride" },
        { "value": "Phosphate", "label": "Phosphate" },
        { "value": "Magnesium", "label": "Magnesium" },
        { "value": "Calcium", "label": "Calcium" }
      ]
    },
    {
      "category": "General Health & Wellness Profile",
      "tests": [
        { "value": "CBC", "label": "Complete Blood Count (CBC)" },
        { "value": "ThyroidProfile", "label": "Thyroid Profile" },
        { "value": "Calcium", "label": "Calcium" },
        { "value": "KidneyHealth", "label": "Kidney Health" },
        { "value": "Phosphate", "label": "Phosphate" },
        { "value": "BoneHealth", "label": "Bone Health" },
        { "value": "Iron", "label": "Iron" },
        { "value": "LipidProfile", "label": "Lipid Profile" },
        { "value": "Ferritin", "label": "Ferritin" },
        { "value": "LiverHealth", "label": "Liver Health" },
        { "value": "HbA1c", "label": "HbA1c" },
        { "value": "InflammationMarker", "label": "Inflammation Marker" },
        { "value": "Glucose", "label": "Glucose" },
        { "value": "FOBT", "label": "Faecal Occult Blood Test (FOBT) / Stool Sample" },
        { "value": "Vitamins", "label": "Essential Vitamins (D, B12)" },
        { "value": "UricAcid", "label": "Uric Acid" }
      ]
    },
    {
      "category": "Female Hormone Profile",
      "tests": [
        { "value": "LH", "label": "Luteinizing Hormone (LH)" },
        { "value": "FSH", "label": "Follicle Stimulating Hormone (FSH)" },
        { "value": "Prolactin", "label": "Prolactin" },
        { "value": "Oestradiol", "label": "Oestradiol (E2)" },
        { "value": "Progesterone", "label": "Progesterone (PRG)" },
        { "value": "AMH", "label": "Anti-Mullerian Hormone (AMH)" },
        { "value": "FAI", "label": "Free Androgen Index (FAI)" },
        { "value": "SHBG", "label": "Sex Hormone-Binding Globulin (SHBG)" },
        { "value": "Testosterone", "label": "Testosterone" },
        { "value": "ThyroidFunction", "label": "Thyroid Function" }
      ]
    },
    {
      "category": "Male Hormone Profile",
      "tests": [
        { "value": "LH", "label": "Luteinizing Hormone (LH)" },
        { "value": "FSH", "label": "Follicle Stimulating Hormone (FSH)" },
        { "value": "Testosterone", "label": "Testosterone (Morning Sample)" },
        { "value": "Prolactin", "label": "Prolactin" },
        { "value": "SHBG", "label": "Sex Hormone-Binding Globulin (SHBG)" },
        { "value": "FAI", "label": "Free Androgen Index (FAI)" }
      ]
    },
    {
      "category": "General Health Profile",
      "tests": [
        { "value": "FBC", "label": "Full Blood Count (FBC)" },
        { "value": "Glucose", "label": "Glucose" },
        { "value": "Cholesterol", "label": "Cholesterol" },
        { "value": "Iron", "label": "Iron Levels" },
        { "value": "Thyroid Testing", "label": "Thyroid Testing" }

      ]
    },

    {
      "category": "Well Man Health Profile",
      "tests": [
        { "value": "Hormone", "label": "Male Hormone Profile" },
        { "value": "Haematology", "label": "Haematology Profile" },
        { "value": "Vitamin", "label": "Vitamin Profile" },
        { "value": "Diabetes", "label": "Diabetic Screening" },
        { "value": "Thyroid", "label": "Thyroid Profile" },
        { "value": "Kidney", "label": "Kidney Health" },
        { "value": "Bone", "label": "Bone Health" },
        { "value": "Lipid", "label": "Lipid Profile" },
        { "value": "Liver", "label": "Liver Health" },
        { "value": "Inflammation", "label": "Inflammation Marker" },
        { "value": "FOBT", "label": "Faecal Occult Blood Test (FOBT) / Stool Sample" }
      ]
    },
    {
      "category": "Female Hormone Profile",
      "tests": [
        { "value": "LH", "label": "Luteinizing Hormone (LH)" },
        { "value": "FSH", "label": "Follicle Stimulating Hormone (FSH)" },
        { "value": "Prolactin", "label": "Prolactin" },
        { "value": "Oestradiol", "label": "Oestradiol (E2)" },
        { "value": "Progesterone", "label": "Progesterone (PRG)" },
        { "value": "AMH", "label": "Anti-Mullerian Hormone (AMH)" },
        { "value": "FAI", "label": "Free Androgen Index (FAI)" },
        { "value": "SHBG", "label": "Sex Hormone-Binding Globulin (SHBG)" },
        { "value": "Testosterone", "label": "Testosterone" },
        { "value": "ThyroidFunction", "label": "Thyroid Function" }
      ]
    },
    {
      "category": "Well Woman Health Profile",
      "tests": [
        { "value": "Hormone", "label": "Female Hormone Profile" },
        { "value": "Haematology", "label": "Haematology Profile" },
        { "value": "Vitamin", "label": "Vitamin Profile" },
        { "value": "Diabetes", "label": "Diabetic Screening" },
        { "value": "Thyroid", "label": "Thyroid Profile" },
        { "value": "Kidney", "label": "Kidney Health" },
        { "value": "Bone", "label": "Bone Health" },
        { "value": "Lipid", "label": "Lipid Profile" },
        { "value": "Liver", "label": "Liver Health" },
        { "value": "Inflammation", "label": "Inflammation Marker" },
        { "value": "FOBT", "label": "Faecal Occult Blood Test (FOBT)" }
      ]
    },
    {
      "category": "Fertility Hormone Multi-Test Package",
      "tests": [
        { "value": "AMH", "label": "Anti-Mullerian Hormone (AMH)" },
        { "value": "LH", "label": "Luteinizing Hormone (LH)" },
        { "value": "FSH", "label": "Follicle Stimulating Hormone (FSH)" },
        { "value": "FAI", "label": "Free Androgen Index (FAI)" },
        { "value": "Oestradiol", "label": "Oestradiol (E2)" },
        { "value": "Progesterone", "label": "Progesterone (Day 21)" },
        { "value": "Prolactin", "label": "Prolactin" },
        { "value": "SHBG", "label": "Sex Hormone-Binding Globulin (SHBG)" },
        { "value": "Testosterone", "label": "Testosterone" },
        { "value": "ThyroidFunction", "label": "Thyroid Function" }
      ]
    },
    {
      "category": "Food & Inhalants Allergy Profile ",
      "tests": [
        { "value": "FoodPanel", "label": "Food Panel" },
        { "value": "InhalantsPanel", "label": "Inhalants Panel" },
      ]
    }
    ,
    {
      "category": "Tropical Travel Profile",
      "tests": [
        { "value": "TropicalTravel", "label": "Tropical Travel Profile" },
        { "value": "EHistolytica", "label": "Amoebic (E. histolytica) Antibodies" },
        { "value": "Schistosome", "label": "Schistosome (Bilharzia) Antibodies" },
        { "value": "Echinococcus", "label": "Echinococcus (Hydatid) Antibodies" },
        { "value": "Leishmania", "label": "Leishmania Antibodies" },
        { "value": "Malaria", "label": "Malarial Parasites" },
        { "value": "ToxoIgG", "label": "Toxoplasma Antibodies IgG" },
        { "value": "ToxoIgM", "label": "Toxoplasma Antibodies IgM" }
      ]
    }
    , {
      "category": "Functional Medicine Tests",
      "tests": [
        { "value": "FoodMap", "label": "Food Map Sensitivity Test" },
        { "value": "FoodPanel", "label": "Food Panel" },
        { "value": "GutHealth", "label": "Full Gut Health Microbiome Test" },
        { "value": "InhalantsPanel", "label": "Inhalants Panel" },
        { "value": "MolecularAllergy", "label": "Molecular Allergy Profile" },
        { "value": "SkinCareDNA", "label": "Skin Care DNA Test" },
        { "value": "HairLossDNA", "label": "Genetic Hair Loss Test" },
        { "value": "DeepSleepDNA", "label": "Deep Sleep DNA Test" }
      ]
    }
    ,
    {
      "category": "Genetic Wellness Tests",
      "tests": [
        { "value": "GeneticWellness", "label": "Genetic Wellness Test - Factor X" },
        { "value": "GeneticSports", "label": "Genetic Sports & Nutrition Test - Factor Y" },
        { "value": "Pharmacogenomic", "label": "Pharmacogenomic Screening - Factor Z" },
        { "value": "HereditaryCancer", "label": "Hereditary Cancer Screening" },
        { "value": "NIPT", "label": "Non-Invasive Prenatal Testing (NIPT)" }
      ]
    }


  ];
  const profileList = [];
  const testList = [];

  testOptions.forEach(item => {
    const name = item.category.toLowerCase();
    const isProfile = name.includes("profile");
    if (isProfile) {
      profileList.push(item);
    } else {
      testList.push(item);
    }
  });

  const selectedTests = formData.requiredTests || [];

  const isTestSelected = (testLabel) => selectedTests.includes(testLabel);

  const handleTestSelect = (testLabel, categoryName = null) => {
    const displayLabel = categoryName ? `${categoryName} (${testLabel})` : testLabel;
    const updated = selectedTests.includes(displayLabel)
      ? selectedTests.filter(t => t !== displayLabel)
      : [...selectedTests, displayLabel];
    setFormData(prev => ({ ...prev, requiredTests: updated }));
  };

  const isCategorySelected = (category) => {
    if (category.tests.length === 0) return selectedTests.includes(category.category);
    return category.tests.every(test =>
      selectedTests.includes(`${category.category} (${test.label})`)
    );
  };

  const handleCategorySelect = (category) => {
    if (category.tests.length === 0) {
      handleTestSelect(category.category);
    } else {
      const allSelected = isCategorySelected(category);
      const allTestLabels = category.tests.map(t => `${category.category} (${t.label})`);
      const updated = allSelected
        ? selectedTests.filter(t => !allTestLabels.includes(t))
        : [...new Set([...selectedTests, ...allTestLabels])];
      setFormData(prev => ({ ...prev, requiredTests: updated }));
    }
  };

  const toggleSection = (section) => {
    setOpenSection(prev => (prev === section ? null : section));
    setOpenCategory(null);
  };

  const toggleCategory = (category) => {
    setOpenCategory(prev => (prev === category.category ? null : category.category));
  };

  const renderCategoryBlock = (category) => (
    <div key={category.category} className="mb-3 border-b border-gray-500 pb-2">
      <div
        className="flex justify-between items-center cursor-pointer text-white font-medium"
        onClick={() => toggleCategory(category)}
      >
        <span className="ml-6">{category.category}</span>
        <input
          type="checkbox"
          checked={isCategorySelected(category)}
          onChange={(e) => {
            e.stopPropagation();
            handleCategorySelect(category);
          }}
          className="ml-[220px] lg:ml-0"
        />
      </div>
      {openCategory === category.category && category.tests.length > 0 && (
        <div className="ml-6 mt-2 space-y-1">
          {category.tests.map(test => (
            <div key={test.value} className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={isTestSelected(`${category.category} (${test.label})`)}
                onChange={() => handleTestSelect(test.label, category.category)}
                className="cursor-pointer ml-[180px] lg:ml-0"

              />
              <span className="text-white text-[12px] lg:text-0 leading-4 ml-10  mt-[60px] lg:mt-16">{test.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <>
      <button
        type="button"
        className="w-full py-[10px] px-4 border-[#4ab0b0] border-[1px] rounded-lg"
        onClick={() => setIsDropdownOpen(true)}
      >
        {selectedTests.length > 0
          ? `${selectedTests.length} Selected`
          : "Pick the Required Categories"}
      </button>

      {isDropdownOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-[#11485B] md:w-[60%] w-[90%] h-[80%] p-4 rounded-lg shadow-lg relative overflow-y-scroll">
            <button
              type="button"
              className="absolute top-0 right-2 text-4xl text-gray-300"
              onClick={() => setIsDropdownOpen(false)}
            >
              &times;
            </button>

            <div className="p-4">
              <input
                className="w-full py-2 px-4 border rounded-lg"
                type="text"
                placeholder="Search Categories or Tests"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="px-4 space-y-6">
              {/* Profile List */}
              <div>
                <h3
                  className="text-white text-xl font-bold border-b pb-1 cursor-pointer"
                  onClick={() => toggleSection("profile")}
                >
                  Test List {openSection === "profile" ? "▲" : "▼"}
                </h3>
                {openSection === "profile" && (
                  <div className="mt-3">
                    {profileList.filter(c => c.category.toLowerCase().includes(searchTerm.toLowerCase()))
                      .map(renderCategoryBlock)}
                  </div>
                )}
              </div>

              {/* Test List */}
              <div>
                <h3
                  className="text-white text-xl font-bold border-b pb-1 cursor-pointer"
                  onClick={() => toggleSection("test")}
                >
                  Profile List {openSection === "test" ? "▲" : "▼"}
                </h3>
                {openSection === "test" && (
                  <div className="mt-3">
                    {testList.filter(c => c.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      c.tests.some(t => t.label.toLowerCase().includes(searchTerm.toLowerCase())))
                      .map(renderCategoryBlock)}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Display Selected Items */}
      <ul className="mt-4 space-y-1 text-sm text-gray-800">
        {Array.isArray(formData.requiredTests) &&
          formData.requiredTests.length > 0 &&
          formData.requiredTests.map((item, index) => (
            <li key={index} className="bg-gray-200 px-3 py-1 rounded-md inline-block mr-2 mb-2">
              {item}
            </li>
          ))}
      </ul>
    </>
  );
};

export default RequiredTestsDropdown;
